import { useClient } from '@adamlip/okeoke.client';
import IconComponent from 'components/IconComponent';
import { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LangIcon from './LangIcon';
import BasketValueIcon from './BasketValueIcon';
import BasketBadgeIcon from './BasketBadgeIcon';
import OrderItemModalV3 from 'components/Modals/OrderItemModalV3';
import { AppParamsContext } from 'contexts/AppParamsContext';

export default function NavIcon({data, size, text}) {
  const {languageCode} = useClient();
  const {appParams} = useContext(AppParamsContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [selected, setSelected] = useState(false);
  const [itemModalOpen, setItemModalOpen] = useState(false);

  const sizes = {
    40: 'w-[40px] h-[40px] p-2',
    55: 'w-[55px] h-[55px] p-3',
    70: 'w-[70px] h-[70px] p-4',
  };

  const textMax = {
    40: 'max-w-[60px]',
    55: 'max-w-[65px]',
    70: 'max-w-[80px]',
  };

  const handleClick = () => {
    if (data?.action === 'selectCategory' && data?.actionParam != null && data?.actionParam.length > 0) {
      navigate(`/order?categoryUUID=${data?.actionParam}`);
    }
    if (data?.action === 'selectItem' && data?.actionParam != null && data?.actionParam?.length > 0) {
      setItemModalOpen(true);
    }
    if (data?.action === 'navigate' && data?.actionParam != null && data?.actionParam?.length > 0) {
      navigate(`/${data?.actionParam}`);
    }
  };

  useEffect(() => {
    if (location?.pathname && data?.action === 'navigate') {
      if (data?.actionParam === 'home') {
        setSelected(location.pathname === '/' || location.pathname.includes(data?.actionParam));
      } else {
        setSelected(location.pathname.includes(data?.actionParam));
      }
    }
  }, [location, data]);

  if (data?.actionParam === 'languageSelector') return <LangIcon text={text} textMax={textMax} size={size} sizes={sizes} />;

  if (data?.actionParam === 'basketValue') return <BasketValueIcon text={text} textMax={textMax} size={size} sizes={sizes} data={data} />;

  if (data?.actionParam === 'basketWithBadge') return <BasketBadgeIcon text={text} textMax={textMax} size={size} sizes={sizes} data={data} />;
  return (
    <>
      <div
        className={`transition-colors flex flex-col shrink-0 gap-1 h-full cursor-pointer`}
        onClick={() => handleClick()}
      >
        <div
          className={`mx-auto ${
            size != null ? sizes?.[size] : "w-[55px] h-[55px] p-3"
          } ${
            selected
              ? "!bg-[var(--bottom-bar-selected-nav-bg-color)]"
              : "!bg-[var(--bottom-bar-nav-bg-color)]"
          } ${appParams?.styles?.borderRadius?.navBar || "rounded-full"} ${
            !selected
              ? "text-[var(--bottom-bar-icon-color)]"
              : "text-[var(--bottom-bar-selected-icon-color)]"
          }`}
        >
          <IconComponent iconCode={data?.iconCode} className={"current"} />
        </div>
        {text !== "hidden" && (
          <div
            className={`${
              selected
                ? "text-[var(--bottom-bar-selected-nav-text-color)]"
                : "text-[var(--bottom-bar-text-color)]"
            } text-sm text-center truncate ${
              size != null ? textMax?.[size] : "max-w-[55px]"
            }`}
          >
            {data?.label?.[languageCode]}
          </div>
        )}
      </div>
      {data?.action === "selectItem" && (
        <OrderItemModalV3
          isOpen={itemModalOpen}
          setIsOpen={setItemModalOpen}
          itemUUID={data?.actionParam}
        />
      )}
    </>
  )
}
